import { ITrackMixed } from '@/data/models/trackMixed';
import {
  IComplexArrayFieldConfig,
  ComplexArrayFieldName,
} from '@/types/multiple-track-types';

export const BASE_TRACK_TEMPLATE: ITrackMixed = {
  title: null,
  version: null,
  displayArtist: null,
  artists: null,
  writersComposers: null,
  publishers: null,
  copyrightYear: null,
  copyrightLine: null,
  phonographicCopyrightYear: null,
  phonographicCopyrightLine: null,
  genre: null,
  audioLanguage: null,
  trackType: null,
};

export const FIELDS_TO_EVALUATE = Object.keys(BASE_TRACK_TEMPLATE) as Array<
  keyof ITrackMixed
>;
export const COMPLEX_ARRAY_FIELDS: Array<keyof ITrackMixed> = [
  'artists',
  'writersComposers',
  'publishers',
];

export const COMPLEX_ARRAY_FIELD_CONFIG: Record<
  ComplexArrayFieldName,
  IComplexArrayFieldConfig
> = {
  artists: {
    keys: ['name', 'performerRole'],
    defaults: { sequence: 0 },
  },
  writersComposers: {
    keys: ['name', 'role'],
  },
  publishers: {
    keys: ['name', 'performing_Rights_Organization'],
  },
};
